// import external dependencies
// import 'jquery';

// Import everything from autoload
//

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import singleProduct from './routes/single-product';
import checkout from './routes/checkout';
import blog from './routes/blog';
import contact from './routes/contact';

/** Populate Router instance with DOM routes */
const routes = new Router({
    // All pages
    common,
    // Home page
    home,
    // Single product
    singleProduct,
    // Checkout
    checkout,
    // Blog
    blog,
    // Contact
    contact,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js